import React from 'react';

export function OrderActionCellIcon(): React.ReactElement {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
			<path d="M10 16V4L18 10L10 16Z" fill="#F3F3F3" />
			<path d="M14 9.19922H2V10.7992H14V9.19922Z" fill="#F3F3F3" />
		</svg>
	);
}

